<template>
  <FormWrapper :handleSubmit="submit" :loading="loading">
    <template #default>
      <b-row class="margin-0">
        <b-col cols="12" class="padding-0">
          <div class="font-size-14 color-complementary-400 margin-bottom-16">
            {{ $lang.terFurtherInformationLabel }}
            (<span class="color-complementary-200">{{ $lang.optional }}</span
            >)
          </div>
          <Checkbox
            :label="$lang.profileImage"
            :value="form.profileImage"
            name="profileImage"
            @input="input"
            @change="changeProfileImage"
          />
          <Checkbox
            :label="$lang.birthDate"
            :value="form.birthDate"
            name="birthDate"
            @input="input"
            @change="changeBirthDate"
          />
          <Checkbox
            :label="$lang.educationGrade"
            :value="form.educationGrade"
            name="educationGrade"
            @input="input"
            @change="changeEducationGrade"
          />
          <Checkbox
            :label="$lang.sokonatCity"
            :value="form.sokonatCity"
            name="sokonatCity"
            @input="input"
            @change="changeSokonatCity"
          />
          <Checkbox
            :label="$lang.jobInfo"
            :value="form.jobInfo"
            name="jobInfo"
            @input="input"
            @change="changeJobInfo"
          />
        </b-col>
      </b-row>
    </template>
  </FormWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { FormWrapper, Checkbox } from "@/components/re-design/forms";
import { pathOr } from "ramda";
import { editTermExtraProfile } from "@/modules/profile/services";
export default {
  mixins: [inputMixin],
  inject: ["TERM_CODE", "TERM_DATA"],
  components: { FormWrapper, Checkbox },
  data() {
    return {
      form: {
        profileImage: false,
        birthDate: false,
        educationGrade: false,
        sokonatCity: false,
        jobInfo: false,
      },
      loading: false,
    };
  },
  watch: {
    TERM_DATA: {
      immediate: true,
      handler(data) {
        this.fetchData(data);
      },
    },
  },
  methods: {
    changeProfileImage(value) {
      this.input("profileImage", value);
    },
    changeBirthDate(value) {
      this.input("birthDate", value);
    },
    changeEducationGrade(value) {
      this.input("educationGrade", value);
    },
    changeSokonatCity(value) {
      this.input("sokonatCity", value);
    },
    changeJobInfo(value) {
      this.input("jobInfo", value);
    },
    async submit() {
      try {
        this.loading = true;
        const termCode = this.TERM_CODE;
        const payload = { termCode, ...this.form };
        const response = await editTermExtraProfile(payload);
        const { message } = response;
        this.$notify.success(message);
        this.$emit("getTermData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    fetchData(data) {
      const profileData = pathOr(null, ["extra_fields", "profile"], data);
      const profileImage = pathOr(false, ["profile_image"], profileData);
      const birthDate = pathOr(false, ["birth_date"], profileData);
      const educationGrade = pathOr(false, ["education_grade"], profileData);
      const sokonatCity = pathOr(false, ["sokonat_city"], profileData);
      const jobInfo = pathOr(false, ["job_info"], profileData);
      this.changeProfileImage(profileImage);
      this.changeBirthDate(birthDate);
      this.changeEducationGrade(educationGrade);
      this.changeSokonatCity(sokonatCity);
      this.changeJobInfo(jobInfo);
    },
  },
};
</script>
